import { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import WeddingDate from "../../components/WeddingDate/WeddingDate";
import CoupleSection2 from "../../components/CoupleSection2/CoupleSection2";
import EventSection from "../../components/EventSection/EventSection";
import VideoSection from "../../components/VideoSection";
import PortfolioSectionS2 from "../../components/PortfolioSectionS2/PortfolioSectionS2";
import PartnerSection from "../../components/PartnerSection";

const AccomodationPage: React.FC = () => {
  return (
    <Fragment>
      <Navbar hclass="wpo-header-style-1" />
      <PageTitle pageTitle="Accomodation" pagesub="Accomodation" />
      <WeddingDate />
      <CoupleSection2/>
      <VideoSection />
      <PortfolioSectionS2 />
      <EventSection />
      <PartnerSection pClass="section-padding" />
      <Footer footerClass="wpo-site-footer" />
      <Scrollbar />
    </Fragment>
  );
};

export default AccomodationPage;
